export enum Language {
  English = 'en',
  German = 'de',
}
